import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonSkiing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.68 7.39a2.5 2.5 0 0 1-.75-.12 2.34 2.34 0 0 1-1.37-1.19 2.37 2.37 0 0 1-.13-1.81l.22-.65a2.34 2.34 0 0 1 1.19-1.37 2.37 2.37 0 0 1 1.81-.13 2.38 2.38 0 0 1 1.5 3l-.22.65a2.34 2.34 0 0 1-1.19 1.37 2.3 2.3 0 0 1-1.06.25M17.9 4a.4.4 0 0 0-.17 0 .4.4 0 0 0-.18.21l-.22.66a.36.36 0 0 0 0 .28.44.44 0 0 0 .21.19.37.37 0 0 0 .29 0 .32.32 0 0 0 .18-.21l.22-.65A.37.37 0 0 0 18 4a.3.3 0 0 0-.1 0M10 11H3a1 1 0 1 0 0 2h8.25l1.581 2.108-1.694 3.389L3.29 16.08a1 1 0 0 0-1.25.67A1 1 0 0 0 2.71 18l10.11 3.07c2.002.619 4.085.932 6.18.93h2a1 1 0 0 0 0-2h-2c-1.89.014-3.77-.256-5.58-.8l-.351-.108 1.79-3.58.002-.003A1 1 0 0 0 14.8 14.4L13.75 13h6.01q.12.015.24 0a1 1 0 0 0 .97-.73A1 1 0 0 0 21 12a1 1 0 0 0-.994-1l-.196-.05a7 7 0 0 1-4.56-3.66l-.291-.575A1 1 0 0 0 13.2 6.4l-3 4a1 1 0 0 0-.055.081l-.005.01A1 1 0 0 0 10 11m2.25 0h3.41a9 9 0 0 1-1.817-2.123z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonSkiing;
